import { getMessage } from './IntlMessages'

export default {
  PRODUCTIVITY_RANKING: {
    type: 'PRODUCTIVITY_RANKING',
    title: getMessage('farmer.portal.productivity.rank'),
    path: '/farmers/productivity-rank-by-region',
    hasForm: false,
    fields: [],
    icon: require('../assets/images/productivity-ranking.svg')
  },
  PLANTING_TIME: {
    type: 'PLANTING_TIME',
    title: getMessage('farmer.portal.planting.time'),
    path: '/farmers/planting-time',
    hasForm: true,
    fields: ['material', 'check'],
    icon: require('../assets/images/planting-time.svg')
  },
  PRODUCTIVITY_REGION: {
    type: 'PRODUCTIVITY_REGION',
    title: getMessage('farmer.portal.productivity.region'),
    path: '/farmers/population-range-by-productivity',
    hasForm: true,
    fields: ['material'],
    icon: require('../assets/images/productivity-region.svg')
  },
  PRODUCTIVE_ENVIRONMENT: {
    type: 'PRODUCTIVE_ENVIRONMENT',
    title: getMessage('farmer.portal.productive.environment'),
    path: '/farmers/productive-environment',
    hasForm: true,
    fields: ['material', 'check'],
    icon: require('../assets/images/productive-environment.svg')
  },
  POPULATION: {
    type: 'POPULATION',
    title: getMessage('farmer.portal.population'),
    path: '',
    hasForm: false,
    fields: [],
    icon: require('../assets/images/population-icon.svg')
  },
  POPULATION_VARIETY: {
    type: 'POPULATION_VARIETY',
    title: getMessage('farmer.portal.population.variety'),
    path: '/farmers/population-variety',
    hasForm: true,
    fields: ['material', 'check'],
    icon: require('../assets/images/population-variety.svg')
  },

  toArray: function () {
    return [
      this.PRODUCTIVITY_RANKING,
      this.PLANTING_TIME,
      this.PRODUCTIVITY_REGION,
      this.PRODUCTIVE_ENVIRONMENT,
      this.POPULATION_VARIETY
    ]
  }
}
